import { initializeApp } from 'firebase/app';
import { getMessaging, isSupported } from 'firebase/messaging';
import { getAnalytics } from 'firebase/analytics';

const firebaseConfig = {
  apiKey: 'AIzaSyCW8y8bc_rrc2yPPqvy-ubVKp_sGLKHzCw',
  authDomain: 'obfs-f0e4d.firebaseapp.com',
  projectId: 'obfs-f0e4d',
  storageBucket: 'obfs-f0e4d.firebasestorage.app',
  messagingSenderId: '450772723739',
  appId: '1:450772723739:web:1d95656e324327c7c070be',
  measurementId: 'G-95NGXFBYEN'
};

const app = initializeApp(firebaseConfig);

// Initialize messaging only if supported to prevent crash on unsupported browsers
let messaging = null;
isSupported().then(supported => {
  if (supported) {
    messaging = getMessaging(app);
  }
}).catch(() => {
  // Silent fail
});

const analytics = typeof window !== 'undefined' ? getAnalytics(app) : null;

export { app, messaging, analytics, isSupported };
